/** Отступы гайдлайнов antd - 8px, 16px, 24px*/
export enum SpacingUnit {
  /** 60px */
  unit15 = 'unit-15',
  /** 56px */
  unit14 = 'unit-14',
  /** 52px */
  unit13 = 'unit-13',
  /** 48px */
  unit12 = 'unit-12',
  /** 44px */
  unit11 = 'unit-11',
  /** 40px */
  unit10 = 'unit-10',
  /** 36px */
  unit9 = 'unit-9',
  /** 32px */
  unit8 = 'unit-8',
  /** 28px */
  unit7 = 'unit-7',
  /** 24px */
  unit6 = 'unit-6',
  /** 20px */
  unit5 = 'unit-5',
  /** 16px */
  unit4 = 'unit-4',
  /** 12px */
  unit3 = 'unit-3',
  /** 8px */
  unit2 = 'unit-2',
  /** 4px */
  unit1 = 'unit-1',
  /** 0px */
  none = 'none',
}

export const spacingUnitToPixels = (unit: SpacingUnit): number => {
  if (unit === SpacingUnit.none) {
    return 0;
  }

  const regex = new RegExp(/\d+/g);

  const result = regex.exec(unit);

  return Number(result ? result : [0]) * 4;
};
